<div class="modal-header">
  <h4 class="modal-title">Are you sure you want to {{ action }} {{ subject }}?</h4>
</div>
<div class="modal-body">
  {{ removeMessage }}
</div>

<div class="modal-footer">
  <button
    id="modalCancelBtn"
    class="btn btn-outline-dark"
    aria-label="Close"
    (click)="onCancel()">
    Cancel
  </button>
  <button
    id="modalAcceptBtn"
    class="btn btn-primary"
    type="submit"
    (click)="onAccept()">
    {{ confirmationBtnText }}
  </button>
</div>
